export class Common {

    static uniqueId(): string {
        return 'idxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    static isNullOrEmpty(value: string | null | undefined) {
        return value == null || value.trim().length <= 0;
    }

    static toUTC(date: Date) {
        return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    }

    static parseJwt(token: string) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    static toLangCode(lang: string | null | undefined): 'en' | 'el' {
        if (lang == null) {
            return 'en';
        }

        if (lang.toUpperCase().includes('EL') || lang.toUpperCase().includes('GR')) {
            return 'el';
        }

        return 'en';
    }

    static roundNumber(n: number | null | undefined) {
        if (n == null) {
            return n;
        }

        return Math.round(n);
    }

    static hash(text: string) {
        var hash = 0,
            i, chr;
        if (text.length === 0) return hash;
        for (i = 0; i < text.length; i++) {
            chr = text.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }

}